// extracted by mini-css-extract-plugin
export default {"Escultura":"Esculturas_Escultura__OAJsR","Navbar":"Esculturas_Navbar__q1z-Z"};